module.exports = __webpack_public_path__ + "static/img/banner8.027bad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner8.png
// module id = 7RQ/
// module chunks = 52